export enum EServerErrorCode {
  SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  METHOD_NOT_SUPPORTED = 'METHOD_NOT_SUPPORTED',
  TIMEOUT = 'TIMEOUT',
  CONFLICT = 'CONFLICT',
  PRECONDITION_FAILED = 'PRECONDITION_FAILED',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  UNPROCESSABLE_CONTENT = 'UNPROCESSABLE_CONTENT',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  CLIENT_CLOSED_REQUEST = 'CLIENT_CLOSED_REQUEST',
  BAD_REQUEST = 'BAD_REQUEST',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
}

export enum EServerErrorMsg {
  /**
   * 用户额度不足错误
   */
  USER_WORD_ERROR = 'USER_WORD_ERROR',

  UPGRADE_ERROR = 'UPGRADE_ERROR',

  AI_GENERATED_ERROR = 'AI_GENERATED_ERROR',

  UNKNOWN_ERROR = 'UNKNOWN_ERROR',

  PERMISSION_ERROR = 'PERMISSION_ERROR',

  METHOD_NOT_SUPPORTED = 'METHOD_NOT_SUPPORTED',

  /**
   * 用户 rewriter 额度不足
   */
  USER_ARTICLE_REWRITER_LIMIT_ERROR = 'USER_ARTICLE_REWRITER_LIMIT_ERROR',
  /**
   * 用户 article blog 额度不足
   */
  USER_ARTICLE_WRITER_LIMIT_ERROR = 'USER_ARTICLE_WRITER_LIMIT_ERROR',
  /**
   * 用户 额度不足
   */
  USER_CREDITS_LIMIT_ERROR = 'USER_CREDITS_LIMIT_ERROR',
  /**
   * 用户 gpt3 额度不足
   */
  USER_GPT3_WORD_LIMIT_ERROR = 'USER_GPT3_WORD_LIMIT_ERROR',

  CHATS_LIMIT_ERROR = 'CHATS_LIMIT_ERROR',

  USER_RECORD_QUOTA_EXCEED_ERROR = 'USER_RECORD_QUOTA_EXCEED_ERROR',
  /**
   * 用户 gpt4 额度不足
   */
  USER_GPT4_WORD_LIMIT_ERROR = 'USER_GPT4_WORD_LIMIT_ERROR',
  /**
   * 用户 语法检测 额度不足
   */
  USER_PLAGIARISM_CHECK_LIMIT_ERROR = 'USER_PLAGIARISM_CHECK_LIMIT_ERROR',

  VALIDATION_ERROR = 'VALIDATION_ERROR',

  NOT_FOUND_ERROR = 'NOT_FOUND_ERROR',

  METHOD_NOT_ALLOWED_ERROR = 'METHOD_NOT_ALLOWED_ERROR',

  UNAUTHORIZED = 'UNAUTHORIZED',

  EMAIL_OR_PASSWORD_REQUIRED = 'Email and password are required',

  USER_DOES_NOT_EXIST = 'User does not exist',

  INCORRECT_USERNAME_OR_PASSWORD = 'Incorrect username or password',

  DEVICE_ID_ERROR = 'DeviceId error',

  EMAIL_VERIFIED_EXPIRED = 'The verification time has expired, please resend the email.',

  EMAIL_HAS_REGISTERED = 'The email has been registered.',

  EMAIL_ERROR = 'The email error.',

  FORBIDDEN = 'FORBIDDEN',

  PARA_ERROR = 'Incorrect Parameter',

  DEPLOY_NAME_ERROR = 'The API deployment for this resource does not exist.',

  INCORRECT_EMAIL_CODE = 'Incorrect email code',

  EMAIL_NOT_VERIFY = 'Email has not been verified yet',

  USER_DURATION_LIMIT_ERROR = 'USER_DURATION_LIMIT_ERROR',
  USER_WORDS_LIMIT_ERROR = 'USER_WORDS_LIMIT_ERROR',
  CONTENT_FILTER_ERROR = 'CONTENT_FILTER_ERROR',
  USER_WORD_LIMIT_MESSAGE = 'USER_WORD_LIMIT_MESSAGE',

  UNAUTHORIZED_DEVICE = 'Your account is already signed in on another device',
  USER_CONCURRENCY_EXCEED = 'USER_CONCURRENCY_EXCEED',

  LYRICS_TOO_LONG = 'LYRICS_TOO_LONG',
  LYRICS_TITLE_TOO_LONG = 'LYRICS_TITLE_TOO_LONG',
  LYRICS_EMPTY = 'LYRICS_EMPTY',
  LYRICS_TITLE_SENSITIVE = 'LYRICS_TITLE_SENSITIVE',
  LYRICS_CONTENT_SENSITIVE = "We couldn't generate your music because your lyrics contain copyrighted or restricted content",
  LYRICS_TITLE_AND_CONTENT_SENSITIVE = 'LYRICS_TITLE_AND_CONTENT_SENSITIVE',
  PROMPT_SENSITIVE = 'PROMPT_SENSITIVE',
  MUSIC_TASK_GENERATE_ERROR = 'Music generation task creation failed',
  MUSIC_TASK_RETRY_ERROR = 'Music task retry failed',
  EMAIL_IS_DISPOSABLE = 'Your email address is invalid. Please try a different one.',
  MUSIC_MODEL_NOT_FOUND = 'Music model not found',
  MUSIC_REFERENCE_AUDIO_LENGTH_ERROR = 'The reference audio must be between 15 seconds and 10 minutes long.',
  MUSIC_REFERENCE_AUDIO_FORMAT_ERROR = 'Unsupported format. Please upload the audio in .WAV or .MP3 format. ',
  MUSIC_REFERENCE_SONG_PURPOSE_ERROR = 'In Song mode, the reference audio should include vocals or accompaniment.',
  MUSIC_REFERENCE_VOICE_PURPOSE_ERROR = 'In Voice mode, the reference audio should include vocals.',
  MUSIC_REFERENCE_INSTRUMENTAL_PURPOSE_ERROR = 'In Instrumental mode, the reference audio should include accompaniment.',
  MUSIC_REFERENCE_AUDIO_PROCESS_ERROR = "We couldn't process the uploaded audio file. Please check the file or try a different one.",
  MUSIC_REFERENCE_AUDIO_TOO_LARGE = 'Please ensure that your uploaded audio file does not exceed 15MB.',
  REFERENCE_NOT_FOUND = 'Reference not found.',
  FILENAME_TOO_LONG = 'The filename must be less than 255 characters.',
  // 歌词目前只支持中文和英文
  LYRICS_NOT_SUPPORT_LANG = 'Lyrics available in Chinese and English only',

  USER_DELETED = 'USER_DELETED',
  UNKNOWN_MODEL = 'Unknown Model',
  TEMPLATE_NOT_FOUND = 'Template not found',
  COVER_MODEL_TRAINING_ERROR = 'Cover model is training, please wait for it to finish.',

  //任务过多限流
  TASK_TOO_MANY_LIMIT = 'Task too many limit',

  // 模型未训练完成
  MODEL_NOT_TRAINED = 'Model not trained',

  URL_NOT_ACCESSIBLE = 'URL not accessible',
  AUDIO_RANGE_ERROR = 'Audio range error, must be between 5 seconds and 60 seconds',

  NETWORK_ERROR = 'Network Error',
}

// 2xxx 表示非应用程序报错，逻辑层面主动抛出错误，5xxx 应用程序本身报错，服务端捕获错误后抛出
export enum ECustomErrorCode {
  // 自定义异常
  USER_WORD_ERROR = 2000,
  USER_ARTICLE_REWRITER_LIMIT_ERROR = 2001,
  USER_ARTICLE_WRITER_LIMIT_ERROR = 2002,
  USER_GPT3_WORD_LIMIT_ERROR = 2003,
  USER_GPT4_WORD_LIMIT_ERROR = 2004,
  USER_PLAGIARISM_CHECK_LIMIT_ERROR = 2005,
  CHATS_LIMIT_ERROR = 2006,

  // 系统异常
  UNKNOWN_ERROR = 5000,
  AI_GENERATED_ERROR = 5001,

  // restful status code
  OK = 200,
  VALIDATION_ERROR = 400,
  NOT_FOUND_ERROR = 404,
  METHOD_NOT_ALLOWED_ERROR = 405,
  UNAUTHORIZED = 401,
}
